<template>
    <div class="charpter3">

<CharpterTree/>

    </div>
</template>
<script>
import CharpterTree from "@/components/CharpterTree.vue";
export default {

    name:"Charpter3",
    components:{
        CharpterTree
    }
}
</script>
<style lang="scss" scoped>

</style>